import { useState, forwardRef, useImperativeHandle } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch as iconSpinner } from '@fortawesome/free-solid-svg-icons';


const Loading = forwardRef((props: any, ref) => {
  const [visible, setVisible] = useState(false);

  const show = (forceShow: boolean | null = null) => setVisible(forceShow === null ? !visible : forceShow);

  useImperativeHandle(
    ref,
    () => ({ show })
  );

  return (
    <div
      {...props}
      className="container justify-content-center align-items-center flex-column fade-out"
      style={{
        display: !visible ? 'none' : 'flex',
        position: 'absolute',
        left: 0,
        right: 0,
        height: '100%',
        width: '100%',
        backgroundColor: '#f5f5f5cc',
        zIndex: 5,
      }}>
      <FontAwesomeIcon spin icon={iconSpinner} size="3x" />
    </div>
  );
});

export default Loading;
